const cpds = [
    {
        title: "The AI Engineer Path",
        summary: "Generative AI in software development. Open Source Models, Embeddings and Vector Databases, Agentic AI, Langchain.",
        provider: "Scrimba",
        course_link: "https://scrimba.com/the-ai-engineer-path-c02v",
        certificate_link: "./assets/certificates/ai_engineer_path.pdf",
        date_completed: "03/01/2025"
    },
        {
        title: "Introduction to AWS",
        summary: "Key concepts related to Containers, Docker, Kubernetes, and Cloud services for containers such as AWS.",
        provider: "Udemy - Rick Crisci",
        course_link: "https://www.udemy.com/share/103xW83@gKzjfaq3xRfKE9nHQ9w5JaDaEaDlMxzPU9l-5vvNXZHzrZMjPfvV75EfEm00tks9Pg==/",
        certificate_link: "./assets/certificates/aws_intro.pdf",
        date_completed: "15/09/2025"
    },
        {
        title: "Containers, Docker, Kubernetes",
        summary: "An introduction to AWS to master AWS fundamentals and learning Hands-on Skills.",
        provider: "Udemy - Rick Crisci",
        course_link: "https://www.udemy.com/share/105j4e3@6vI9vtUwNK30VWZeutDtASaC00cccrMlQ55WE40nKmAOCgrhLe4X9MDgW6mu89tGjg==/",
        certificate_link: "./assets/certificates/container_docker_kubernetes.pdf",
        date_completed: "14/10/2025"
    } 
]

export default cpds